module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-ruled-fill-afab46d4.svg";